import { createContext, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { generateGuid } from '../util/gtmTracking';

const GtmPageViewContext = createContext(null);

export function GtmPageViewProvider({ children }) {
    const location = useLocation();
    // History keys can be reused on Back; generate a new ID for each arrival instead.
    let [visit, setVisit] = useState(() => ({ location, pageViewId: generateGuid() }));
    if (visit.location !== location) {
        const nextVisit = { location, pageViewId: generateGuid() };
        setVisit(nextVisit);
        visit = nextVisit;
    }

    return <GtmPageViewContext.Provider value={visit.pageViewId}>
        {children}
    </GtmPageViewContext.Provider>;
}

export function useGtmPageViewId(pageName) {
    const pageViewId = useContext(GtmPageViewContext);
    let [fallback, setFallback] = useState(() => ({ pageName, pageViewId: pageViewId || generateGuid() }));
    if (!pageViewId && fallback.pageName !== pageName) {
        const nextFallback = { pageName, pageViewId: generateGuid() };
        setFallback(nextFallback);
        fallback = nextFallback;
    }
    return pageViewId || fallback.pageViewId;
}
